import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ✅ Updated GA4 Measurement ID
const MEASUREMENT_ID = "G-5V6RKJ7JDR";

export default function useGA() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;

    const sendPageView = (tries = 0) => {
      if (window.gtag) {
        window.gtag("config", MEASUREMENT_ID, {
          page_path: path,
          ...(process.env.NODE_ENV === "development" ? { debug_mode: true } : {}),
        });
      } else if (tries < 6) {
        setTimeout(() => sendPageView(tries + 1), 500);
      } else {
        console.warn("gtag not available — page_view not sent:", path);
      }
    };

    sendPageView();
  }, [location]);
}
